// --------------------------------------------------------------
// Created On: 2023-06-23
// Author: Zachary Thomas
//
// Last Modified: 2026-08-03
// Modified By: Zachary Thomas
//
// Copyright 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./FilterStationVisual.module.scss";

// A data visualization for a filter station.
export default function FilterStationVisual(): Component {
  return (
    <div className="row g-0">
      <div className={`${styles.svgContent} col-12 col-lg-6`}>
        <img
          className={styles.base}
          src="/productVisuals/centrifugalPump/centrifugalPump_base.svg"
          alt="Pump Data Visualization"
        />
        <img
          className={styles.impellerOff}
          src="/productVisuals/centrifugalPump/centrifugalPump_impeller.svg"
          alt="Pump Data Visualization"
        />
        <img
          className={styles.suction}
          src="/productVisuals/centrifugalPump/centrifugalPump_suction.svg"
          alt="Pump Data Visualization"
        />
        <img
          className={styles.topHide}
          src="/productVisuals/centrifugalPump/centrifugalPump_hide_ta.svg"
          alt="Pump Data Visualization"
        />
        <img
          className={styles.bottomHide}
          src="/productVisuals/centrifugalPump/centrifugalPump_hide_ba.svg"
          alt="Pump Data Visualization"
        />
        <img
          className={styles.eye}
          src="/productVisuals/centrifugalPump/centrifugalPump_eye.svg"
          alt="Pump Data Visualization"
        />
      </div>
    </div>
  );
}
